import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import TrackingDescription from 'components/molecules/CardLayerTracking/fragments/TrackingDescription';
// import { TrackingDescriptionID } from 'defs/tracking';
import { actionCreators as trackingAC, getDescriptionForGuide, getIsGuideOpen } from 'store/trackingDescription';

export type TrackingDescriptionOwnPropsType = {
	id: any; // TrackingDescriptionID
};

const mapStateToProps = (state: any, ownProps: TrackingDescriptionOwnPropsType) => ({
	id: ownProps.id,
	description: getDescriptionForGuide(state, ownProps.id),
	open: getIsGuideOpen(state, ownProps.id),
});

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			doCloseDescription: trackingAC.doCloseDescription,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(TrackingDescription as any);
